import React from 'react';
import { styled } from '@nykaa/ui-components';
import BackArrowIcon from 'shared/components/Icons/BackArrow';
import { handleHistoryBack } from './helpers';

const BackButton = styled.button<{ isTransparentBG: boolean; color?: string }>`
  border: none;
  background: rgba(255, 255, 255, 0.2);
  ${({ isTransparentBG, color }) =>
    (isTransparentBG || color) && 'background: transparent;'};
  border-radius: 50%;
  width: 48px;
  height: 48px;
  padding: 10px;
`;

interface BackNavProps {
  fillColor?: string;
  isTransparentBG?: boolean;
  color?: string;
}

const BackNav = ({
  fillColor,
  isTransparentBG = false,
  color,
}: BackNavProps) => (
  <BackButton
    type="button"
    onClick={handleHistoryBack}
    isTransparentBG={isTransparentBG}
    color={color}
    aria-label="Back"
  >
    <BackArrowIcon fillColor={fillColor} />
  </BackButton>
);

export default BackNav;
